<mat-form-field appearance="outline" *ngIf="view === 'data'">
    <mat-label>{{ field?.label }}</mat-label>
    <input matInput
        id=""
        type="text"
        [ngModel]="value"
        (ngModelChange)="updateValue($event)"
        [required]="required"
        [readonly]="true"
    />
</mat-form-field>

<mat-form-field appearance="outline" *ngIf="view === 'fill'" subscriptSizing="dynamic">
  <mat-label>{{ label }}</mat-label>
  <mat-select [value]="value" (valueChange)="updateValue($event)" [required]="required">
    <mat-option *ngFor="let option of field?.options" [value]="option.label">{{ option.label }}</mat-option>
  </mat-select>
</mat-form-field>

<table class="table" *ngIf="view === 'edit'">

  <tr>
    <th class="label-option">
      Options
      <button mat-icon-button color="primary"
        matTooltip="Ajouter" matTooltipPosition="right" (click)="add()">
        <mat-icon>add</mat-icon>
      </button>
    </th>
    <td class="action-add">
    </td>
  </tr>

  <tr *ngFor="let option of options; let i = index;">
    <td class="label">
      <mat-form-field appearance="outline" style="width: 100%" subscriptSizing="dynamic">
        <mat-label>Option {{ i + 1 }}</mat-label>
        <input matInput id="" required
          [ngModel]="option.label"
          (ngModelChange)="updateOption(i, $event)"
        />
      </mat-form-field>
    </td>
    <td class="action">
      <button mat-icon-button color="primary"
        matTooltip="Déplacer vers le bas"
        (click)="toDown(i)"
        [disabled]="i === (options.length - 1)">
        <mat-icon>arrow_downward</mat-icon>
      </button>
      <button mat-icon-button color="primary"
        matTooltip="Déplacer vers le haut"
        (click)="toUp(i)"
        [disabled]="i === 0">
        <mat-icon>arrow_upward</mat-icon>
      </button>
      <button mat-icon-button
        matTooltip="Supprimer" color="warn"
        (click)="remove(i)" [disabled]="options.length <= 2">
        <mat-icon>delete</mat-icon>
      </button>
    </td>
  </tr>

</table>
